import { makeStyles } from "@material-ui/core/styles";
import Drawer from '@material-ui/core/Drawer';
import clsx from 'clsx';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  list: {
    border: "1px solid rgb(132, 124, 124,0.5)",
    borderRadius: 5,
    padding: 0
  },
  selected: {
    borderLeft: "2px solid #d40808"
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
}));

export default function SideMenu({history, match = {}, showBilling}) {
  const classes = useStyles();
  const {pathname = ""} = history.location
  return (
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper),
        }}
        open={true}
      >
        <List component="nav" className={classes.list}>
          <ListItem button className={pathname.includes("about")? classes.selected:""}>
            <ListItemText primary="Profile" onClick={()=>history.push("about")}/>
          </ListItem>
          <ListItem button className={pathname.includes("update-password")? classes.selected:""}>
            <ListItemText primary="Account Security"  onClick={()=>history.push("update-password")} />
          </ListItem>
          {showBilling && <ListItem button className={pathname.includes("billing")? classes.selected:""}>
            <ListItemText primary="Billing"  onClick={()=>history.push("billing")} />
          </ListItem>
          }
        </List>
      </Drawer>
  );
}
